/* eslint-disable */

export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[];
    };
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        EventContent: [
            'CreateDeliveryContent',
            'RequestRevisionContent',
            'AppointmentContent',
            'StartCollaborationContent',
            'ApproveCollaborationContent',
        ],
        DynamicField: [
            'SelectChoiceField',
            'MultiSelectChoiceField',
            'GridChoiceField',
            'RadioChoiceField',
            'MultiChoiceField',
            'BudgetField',
            'DateField',
            'FilesField',
            'TextAreaField',
            'SquarespacePackageChoiceField',
            'LogoContestTierChoiceField',
            'ContestUpgradesChoiceField',
            'PrintServiceOptionsField',
            'InputField',
            'MultiInputField',
            'MultiGridChoiceField',
            'ClientConfiguredField',
            'WorkEntityField',
            'IntelligentStylesField',
            'BooleanField',
        ],
        IProduct: ['ProductFixedPriceProject'],
        YourWorkItem: ['StandardWorkItem', 'OrderWorkItem'],
        ProjectContextMessageAndActions: [
            'ContextMessageAndActionsCompletedProject',
            'ContextMessageAndActionsLockedProject',
            'ContextMessageAndActionsStartedProject',
            'ContextMessageAndActionsInvitedProject',
        ],
        OrderWorkSubItem: ['OrderWorkSubItemProject'],
    },
};
export default result;
